var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"dynamic-fields-form"},[(_vm.formFields)?_c('AddContentRenderer',{attrs:{"form":_vm.formFields,"active-page-override":_vm.activeStepNumber,"edit-mode":true,"entity":_vm.contentForm.values}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }